import React from 'react';
import Cropper from 'react-easy-crop';

import { makeid, postData } from './misc';
import imageCompression from 'browser-image-compression';

export default function FormComponent() {
    const [file, setFile] = React.useState()
    const [thename, setTheName] = React.useState("")
    
    function handleChange(event) {
        setFile(event.target.files[0])
    }

    async function compressFile(file) {
        try {
          const compressedFile = await imageCompression(file, options);
          return compressedFile;
        } catch (error) {
          console.error('Image compression error:', error);
          return file; // Fallback to original file if compression fails
        }
    }
    
    function handleSubmit(event) {
        event.preventDefault()
        const url = '/api/sirri_api/uploadFile';
        const formData = new FormData();
        
        compressFile(file).then((compressedFile) => {
            formData.append('file', compressedFile);
        })
        
        formData.append('fileName', file.name);
        formData.append('name', thename);

        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        };
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        console.log(formData)
        postData(url, formData, config).then((data) => {
            console.log(data);
            alert("Saved successfully")
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        })
    }
    return (
        <div className="mb-3">
            <form onSubmit={handleSubmit} className="flex flex-col">
                <p className="text-base text-white">This form is specifically for uploading images. When you want to edit a profile, click on one of the images and you'll be given the option to delete the image or edit the profile to make it a proper file.</p>

                <label className="block mb-2 text-sm font-medium text-gray-100" htmlFor="file_input">Upload file</label>
                <input className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none mb-3" id="file_input" type="file" onChange={handleChange}/>

                <input type="text" className="bg-white placeholder-gray-600 text-black p-3 rounded-full" placeholder='The Name:' onChange={(e) => setTheName(e.target.value)}/>
                <button type="submit" className="text-black bg-white p-2 m-2 rounded-full">Upload</button>
            </form>
        </div>
    )
}

async function getCroppedImg(imageSrc, cropPixels) {
  const image = new Image()
  image.src = imageSrc
  await new Promise((r, e) => { image.onload = r; image.onerror = e })

  const canvas = document.createElement('canvas')
  canvas.width = cropPixels.width
  canvas.height = cropPixels.height

  const ctx = canvas.getContext('2d')
  ctx.drawImage(
    image,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    cropPixels.width,
    cropPixels.height
  )

  return await new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), 'image/png')
  })
}

export function ImageFormComponent(props) {
    const [successfulupload, setSuccessfulUpload] = React.useState(false)
    const [errorpresent, setErrorPresent] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [selectedFile, setSelectedFile] = React.useState(null)
    const [previewUrl, setPreviewUrl] = React.useState(null)
    const [croppedPreviewUrl, setCroppedPreviewUrl] = React.useState(null)
    const [isCropModalOpen, setIsCropModalOpen] = React.useState(false)
    const [crop, setCrop] = React.useState({ x: 0, y: 0 })
    const [zoom, setZoom] = React.useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null)
    const [fileInputKey, setFileInputKey] = React.useState(0)

    React.useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl)
            }
        }
    }, [previewUrl])

    React.useEffect(() => {
        return () => {
            if (croppedPreviewUrl) {
                URL.revokeObjectURL(croppedPreviewUrl)
            }
        }
    }, [croppedPreviewUrl])

    function handleChange(event) {
        const incomingFile = event.target.files && event.target.files[0]

        if (!incomingFile) {
            setErrorPresent(true)
            setSuccessfulUpload(false)
            return
        }

        setSelectedFile(incomingFile)
        setPreviewUrl(URL.createObjectURL(incomingFile))
        setCroppedPreviewUrl(null)
        setCrop({ x: 0, y: 0 })
        setZoom(1)
        setCroppedAreaPixels(null)
        setSuccessfulUpload(false)
        setErrorPresent(false)
        setIsCropModalOpen(true)
    }

    const resetState = React.useCallback(() => {
        setSelectedFile(null)
        setPreviewUrl(null)
        setCroppedPreviewUrl(null)
        setCrop({ x: 0, y: 0 })
        setZoom(1)
        setCroppedAreaPixels(null)
        setIsCropModalOpen(false)
        setFileInputKey((value) => value + 1)
    }, [])

    const handleCropCancel = React.useCallback(() => {
        resetState()
    }, [resetState])

    const handleCropConfirm = React.useCallback(async () => {
        if (!previewUrl || !croppedAreaPixels || !selectedFile) {
            return
        }

        try {
            const croppedBlob = await getCroppedImg(previewUrl, croppedAreaPixels)

            if (!croppedBlob) {
                throw new Error('Unable to crop the selected image.')
            }

            const previewObjectUrl = URL.createObjectURL(croppedBlob)
            setCroppedPreviewUrl((prev) => {
                if (prev) {
                    URL.revokeObjectURL(prev)
                }
                return previewObjectUrl
            })
            setIsCropModalOpen(false)
            setLoading(true)
            setSuccessfulUpload(false)
            setErrorPresent(false)

            await new Promise((resolve) => setTimeout(resolve, 0))

            const croppedFileName = `${makeid(10)}.png`
            const croppedFile = new File([croppedBlob], croppedFileName, { type: croppedBlob.type || 'image/png' })

            const url = '/api/sirri_api/uploadFile'
            const formData = new FormData()

            formData.append('file', croppedFile)
            formData.append('fileName', croppedFileName)

            if (props.gender === "Male") {
                formData.append('name', props.EMAIL)
                formData.append('gender', 'Male')
            } else {
                formData.append('name', props.EMAIL)
                formData.append('gender', 'Female')
            }

            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            }

            const data = await postData(url, formData, config)
            setSuccessfulUpload(false)
            setErrorPresent(false)
            console.log(data)

            if (data.responsecode !== 500 && data.responsecode !== 400) {
                setSuccessfulUpload(true)
                setLoading(false)
                setTimeout(() => {
                    if (props.nextstep) props.nextstep()
                }, 1000)
                resetState()
            } else {
                if (data.responsecode === 400) {
                    alert("Your picture didn't go up properly. You can continue to fill the form but be sure to upload your image once you get into your account.")
                }
                setErrorPresent(true)
                setLoading(false)
                resetState()
            }
        } catch (err) {
            console.log("Error in setProfiledataSubmit: ", err)
            setErrorPresent(true)
            setLoading(false)
            resetState()
            throw err
        }
    }, [previewUrl, croppedAreaPixels, selectedFile, props.gender, props.fullname1, props.EMAIL, props.nextstep, resetState])

    return (
        <div className="mb-3">
                {successfulupload
                    ? <p className="bg-green-500 text-base">Uploaded successfully</p>
                    : null
                }
                {errorpresent
                    ? <p className="bg-green-500 text-base">Upload failed. Contact support.</p>
                    : null
                }
                {loading
                    ? <p className="bg-yellow-500 text-base">Uploading, please wait</p>
                    : null
                }
                {croppedPreviewUrl && (
                    <div className="flex justify-center mb-3">
                        <img
                            src={croppedPreviewUrl}
                            alt="Cropped preview"
                            className="w-32 h-auto rounded-full object-cover border-2 border-white"
                        />
                    </div>
                )}
                <label className="block mb-2 text-sm font-medium text-gray-100" htmlFor="file_input">Upload file</label>
                <input
                    key={fileInputKey}
                    className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none mb-3"
                    id={"file_input"+props.id}
                    type="file"
                    accept="image/*"
                    onChange={handleChange}
                />
                {isCropModalOpen && previewUrl && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
                        <div className="bg-white rounded-lg p-4 max-w-lg w-full">
                            <div className="relative w-full h-72 md:h-96 bg-black">
                                <Cropper
                                    image={previewUrl}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={9 / 16}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={(_, croppedAreaPixels) => setCroppedAreaPixels(croppedAreaPixels)}

                                />
                            </div>
                            {croppedPreviewUrl && (
                                <div className="mt-4 flex justify-center">
                                    <img src={croppedPreviewUrl} alt="Preview" className="w-24 h-auto rounded-full object-cover" />
                                </div>
                            )}
                            <div className="mt-4 flex justify-end space-x-2">
                                <button
                                    type="button"
                                    className="px-4 py-2 rounded-full bg-gray-200 text-gray-800"
                                    onClick={handleCropCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="px-4 py-2 rounded-full bg-blue-600 text-white"
                                    onClick={handleCropConfirm}
                                >
                                    Confirm Crop
                                </button>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    )
}

function createImage(url) {
    return new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', (error) => reject(error))
        image.setAttribute('crossOrigin', 'anonymous')
        image.src = url
    })
}

export async function getCircularCrop(imageSrc, croppedAreaPixels) {
    if (!croppedAreaPixels) {
        return null
    }

    const image = await createImage(imageSrc)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    if (!ctx) {
        throw new Error('Canvas context not available')
    }

    const size = 640
    canvas.width = size
    canvas.height = size

    ctx.save()
    ctx.beginPath()
    ctx.arc(size / 2, size / 2, size / 2, 0, 2 * Math.PI)
    ctx.closePath()
    ctx.clip()

    ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        size,
        size
    )

    ctx.restore()

    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob) {
                resolve(blob)
            } else {
                reject(new Error('Canvas is empty'))
            }
        }, 'image/png')
    })
}
